import _ from 'lodash'
import { createSelectorCreator, defaultMemoize } from 'reselect'
import isEqual from 'shallowequal'
import { Roles } from 'Src/constants/Roles'
import { terBankRoles } from 'Src/constants/OkoRoles'
import { store } from 'Src/store'
import field_partner_tab from 'Src/locale/ru/field_partner_tab.json'

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual)

export const availableActions = createDeepEqualSelector(
	(props) => props.roles,
	(props) => props.function_aliases,
	(roles, function_aliases) => {
		// if( _.size(roles) ) {
		// 	const functions = _.map(roles || [], role => role.functions)
		// 	const access = _.map(_.unionBy(...functions, 'alias'), role => role.alias).sort()
		// 	return access
		// } else {
		// 	return function_aliases
		// }
		return function_aliases
	}
)

export const isAdmin = createDeepEqualSelector(
	(props) => props.is_admin,
	(is_admin) => {
		return is_admin
	}
)

export const isAnalystDSCA = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'analyst_ds_ca') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isRun = (state) => state.map((i) => i.slug).includes(Roles.RUN)

export const isBusinessAdministrator = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'biznes-administrator') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isSuperAdmin = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'superadmin') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isDeveloper = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'developer') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isTechSupport = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'tech_support') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isTechSupportLineOne = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'tech_support_line_1') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isKorrektirovschikBlokirovok = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'korrektirovschik-blokirovok') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isBusinessRegistrator = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'biznes-registrator') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isViewOrderMyPartners = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (
				value.slug === 'biznes-administrator' ||
				value.slug === 'admin' ||
				value.slug === 'regionalnyy-menedzher' ||
				value.slug === 'territorialnyy-menedzher'
			) {
				access = true
				return false
			}
		})
		return access
	}
)

export const isViewOrderTerrBank = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (
				value.slug === 'biznes-administrator' ||
				value.slug === 'admin' ||
				value.slug === 'regionalnyy-menedzher' ||
				value.slug === 'territorialnyy-menedzher' ||
				value.slug === 'sotrudnik-bank' ||
				value.slug === 'rukovoditel-bank'
			) {
				access = true
				return false
			}
		})
		return access
	}
)

// "менеджер Сбербанка",
// "менеджер ДС"
export const isInstructionColloborator = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (
				value.slug === 'biznes-administrator' ||
				value.slug === 'admin' ||
				value.slug === 'regionalnyy-menedzher' ||
				value.slug === 'territorialnyy-menedzher' ||
				value.slug === 'manager-ds' ||
				value.slug === 'menedzher-sberbanka'
			) {
				access = true
				return false
			}
		})
		return access
	}
)

export const isTerrManager = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'territorialnyy-menedzher') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isSberManager = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'menedzher-sberbanka') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isRegistratorDS = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'registrar_ds') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isDsManager = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'manager-ds') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isSecurity = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'security') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isRukovoditel = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'rukovoditel') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isManager = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'manager') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isBlockCreatePartnerManager = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (
				value.slug === 'regionalnyy-menedzher' ||
				value.slug === 'territorialnyy-menedzher' ||
				value.slug === 'senior_manager'
			) {
				access = true
				return false
			}
		})
		return access
	}
)

// Временное решение, пока на бэке не реализуют подобный функционал для всех полей
export const FIELDS_WITH_BACKEND_PERMISSIONS = [
	'business_type_id',
	'partner_type_id',
	'manager_id',
	'merchant_ids',
	'channel_ids',
	'target_partner_ids',
	'linked_products',
	'notification_type_ids',
	'skip_call',
	'is_active',
	'is_renewal',
	'rbidos',
	'infotecs_request_regardless_of_document_types',
	'rbidos_order_autocreate',
	'documents_comment',
	'dzo',
	'digital_confirmations',
	'product_profiles',
	'sber_mq_products',
	'bg_api_callback_token',
	'bg_api_callback_endpoint',
	'show_activity',
	'free_rbidos_request',
	'stop_sms_in_orders',
	'direction_type',
	'observer_ids',
	'foreign_agent',
	'is_forbids_orders',
	'offer_type',
]

export const getViewFields = createDeepEqualSelector(
	(props) => props.auth.roles,
	(props) => props.page?.entity,
	(roles, entity) => {
		const fields = {}

		FIELDS_WITH_BACKEND_PERMISSIONS.forEach((fieldName) => {
			fields[fieldName] = {
				view: Object.keys(entity).includes(fieldName),
				edit: Boolean(entity?.editable_attributes?.includes(fieldName)),
			}
		})

		return fields
	}
)

export const isTabError = createDeepEqualSelector(
	(props) => props.formError,
	(formError) => {
		const errorTab = { tab_1: false, tab_2: false }
		_.each(formError, (val, key) => {
			if (field_partner_tab[key]) errorTab[field_partner_tab[key].tab] = true
		})
		return errorTab
	}
)

export const idsTB = createDeepEqualSelector(
	(props) => props.entries,
	(entries) => {
		const ids = []
		_.each(entries, (value) => {
			if (terBankRoles.includes(value.slug)) {
				ids.push(value.id)
			}
		})
		return ids
	}
)

export const isSettingGrid = createDeepEqualSelector(
	(props) => _.get(props, 'roles', []),
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (
				value.slug === 'manager-ds' ||
				value.slug === 'product_specialist' ||
				value.slug === 'admin' ||
				value.slug === 'superadmin'
			) {
				access = true
				return false
			}
		})
		return access
	}
)

export const idAdmin = createDeepEqualSelector(
	(props) => (props && props.entries) || [],
	(entries) => {
		let findId = null
		_.each(entries, (value) => {
			const { slug, id } = value
			if (slug === 'admin') {
				findId = id
			}
		})
		return findId
	}
)

export const auth = {
	loggedIn() {
		const state = store.getState()
		return !!_.get(state, 'auth.eo_token')
	},
}

export const isSeniorManager = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'senior_manager') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isQaExpert = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'qa_expert') {
				access = true
				return false
			}
		})
		return access
	}
)

export const isHrManager = createDeepEqualSelector(
	(props) => props.roles,
	(roles) => {
		let access = false
		_.each(roles, (value) => {
			if (value.slug === 'hr_manager') {
				access = true
				return false
			}
		})
		return access
	}
)
